// ref: https://nextjs.org/docs/advanced-features/error-handling
// ret: https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/error_boundaries/

import React, { Component, ErrorInfo, ReactNode } from 'react'
import { ErrorPage } from '../Body/ErrorPage'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage redirect={false} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
